const reportTheme = {
  id: 305,
  name: "Aus Pyramid",
  slug: "aus-pyramid",
  title: "TEST REPORT THEME",
  description:
    "<p> (DOM) - MB - Mackay = 67</p><p>Australian Capital Territory = 173,618</p><p>New South Wales = 3,124,151</p>",
  clientID: 1,
  use_for_summary: false,
  allow_for_custom: true,
  country: "Australia",
};

const items = [
  {
    id: 323,
    reportThemeID: 1,
    text: null,
    chartType: "Pyramid",
    chartRef: "17298635925179",
    itemName: "Indigenous Population",
    itemSource: "tralian Bureau of Statistics (ABS)",
    chartDescription: "Indigenous Population by Age and Gender",
    chartXLabel: null,
    chartYLabel: null,
    syncChartWithHTMLTableRef: null,
    inverseChartData: true,
    chartXCommaSeperatedValues: null,
    chartYCommaSeperatedValues: null,
    indicatorHTMLTableRef: null,
    HTMLTableType: 1,
    indicatorHTMLTableDescription: null,
    domainHTMLTableColOneText: null,
    domainHTMLTableColTwoText: null,
    order: 2,
    timeSeries: true,
    showComparators: true,
    kpi_config: null,
    display_data_point_markers: false,
    left_label: "Female",
    right_label: "Male",
    comparator: "C1",
    indicators: [
      {
        id: 650,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_65_y_ov_Indigenous_F*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 4,
        y_label: "Aged 65 +",
        indicatorName: "Indigenous females aged 65+ years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 638,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_65_y_ov_Indigenous_M*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 6,
        y_label: "Aged 65 +",
        indicatorName: "Indigenous males aged 65+ years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 651,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_60_64_y_Indigenous_F*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 7,
        y_label: "Aged 60 to 64",
        indicatorName: "Indigenous females aged 60 to 64 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 637,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_60_64_y_Indigenous_M*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 8,
        y_label: "Aged 60 to 64",
        indicatorName: "Indigenous males aged 60 to 64 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 649,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_55_59_y_Indigenous_F*dr",
        indicatorDate: null,
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 9,
        y_label: "Aged 55 to 59",
        indicatorName: "Indigenous females aged 55 to 59 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 636,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_55_59_y_Indigenous_M*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 10,
        y_label: "Aged 55 to 59",
        indicatorName: "Indigenous males aged 55 to 59 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 653,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_50_54_y_Indigenous_F*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 11,
        y_label: "Aged 50 to 54",
        indicatorName: "Indigenous females aged 50 to 54 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 635,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_50_54_y_Indigenous_M*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 12,
        y_label: "Aged 50 to 54",
        indicatorName: "Indigenous males aged 50 to 54 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 646,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_45_49_y_Indigenous_F*dr",
        indicatorDate: null,
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 13,
        y_label: "Aged 45 to 49",
        indicatorName: "Indigenous females aged 45 to 49 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 634,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_45_49_y_Indigenous_M*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 14,
        y_label: "Aged 45 to 49",
        indicatorName: "Indigenous males aged 45 to 49 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 655,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_40_44_y_Indigenous_F*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 15,
        y_label: "Aged 40 to 44",
        indicatorName: "Indigenous females aged 40 to 44 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 633,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_40_44_y_Indigenous_M*dr",
        indicatorDate: null,
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 16,
        y_label: "Aged 40 to 44",
        indicatorName: "Indigenous males aged 40 to 44 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 644,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_35_39_y_Indigenous_F*dr",
        indicatorDate: null,
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 17,
        y_label: "Aged 35 to 39",
        indicatorName: "Indigenous females aged 35 to 39 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 631,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_35_39_y_Indigenous_M*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 18,
        y_label: "Aged 35 to 39",
        indicatorName: "Indigenous males aged 35 to 39 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 642,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_30_34_y_Indigenous_F*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 19,
        y_label: "Aged 30 to 34",
        indicatorName: "Indigenous females aged 30 to 34 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 659,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_30_34_y_Indigenous_M*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 20,
        y_label: "Aged 30 to 34",
        indicatorName: "Indigenous males aged 30 to 34 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 641,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_25_29_y_Indigenous_F*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 21,
        y_label: "Aged 25 to 29",
        indicatorName: "Indigenous females aged 25 to 29 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 630,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_25_29_y_Indigenous_M*dr",
        indicatorDate: null,
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 22,
        y_label: "Aged 25 to 29",
        indicatorName: "Indigenous males aged 25 to 29 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 640,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_20_24_y_Indigenous_F*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 23,
        y_label: "Aged 20 to 24",
        indicatorName: "Indigenous females aged 20 to 24 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 628,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_20_24_y_Indigenous_M*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 24,
        y_label: "Aged 20 to 24",
        indicatorName: "Indigenous males aged 20 to 24 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 639,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_15_19_y_Indigenous_F*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 25,
        y_label: "Aged 15 to 19",
        indicatorName: "Indigenous females aged 15 to 19 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 627,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_15_19_y_Indigenous_M*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 26,
        y_label: "Aged 15 to 19",
        indicatorName: "Indigenous males aged 15 to 19 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 625,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_10_14_y_Indigenous_F*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 27,
        y_label: "Aged 10 to 14",
        indicatorName: "Indigenous females aged 10 to 14 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 657,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_10_14_y_Indigenous_M*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 28,
        y_label: "Aged 10 to 14",
        indicatorName: "Indigenous males aged 10 to 14 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 623,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_5_9_y_Indigenous_F*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 29,
        y_label: "Aged 5 to 9",
        indicatorName: "Indigenous females aged 5 to 9 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 624,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_5_9_y_Indigenous_M*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 30,
        y_label: "Aged 5 to 9",
        indicatorName: "Indigenous males aged 5 to 9 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 621,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_0_4_y_Indigenous_F*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 33,
        y_label: "Aged 0 to 4",
        indicatorName: "Indigenous females aged 0 to 4 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
      {
        id: 622,
        indicatorHTMLTableRef: null,
        chartRef: "17298635925179",
        indicatorCode: "A_0_4_y_Indigenous_M*dr",
        indicatorDate: "0",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 32,
        y_label: "Aged 0 to 4",
        indicatorName: "Indigenous males aged 0 to 4 years",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 2,
        dateCoverageText: "2021",
      },
    ],
  },
];

const comparatorAreaCodes = ["ASTE8", "ASTE1", "CSTM55"];

const comparatorsList = [
  { area_code: "ASTE8", area_name: "Aus Comparator 1" },
  { area_code: "ASTE1", area_name: "Aus Comparator 2" },
  { area_code: "CSTM55", area_name: "Aus Comparator 3" },
];

const indicatorValues = {
  "CSTM55.P_Tot_Married.2021-01-01.G05: PERSONS_Total_Married": "67",
  "ASTE8.P_Tot_Married.2021-01-01.G05: PERSONS_Total_Married": "173,618",
  "ASTE1.P_Tot_Married.2021-01-01.G05: PERSONS_Total_Married": "3,124,151",

  "CSTM55.A_65_y_ov_Indigenous_F*dr.2021-01-01.Indigenous females aged 65+ years.rate":
    "0.16%",
  "ASTE8.A_65_y_ov_Indigenous_F*dr.2021-01-01.Indigenous females aged 65+ years.rate":
    "0.09%",
  "ASTE1.A_65_y_ov_Indigenous_F*dr.2021-01-01.Indigenous females aged 65+ years.rate":
    "0.23%",
  "CSTM55.A_65_y_ov_Indigenous_M*dr.2021-01-01.Indigenous males aged 65+ years.rate":
    "0.15%",
  "ASTE8.A_65_y_ov_Indigenous_M*dr.2021-01-01.Indigenous males aged 65+ years.rate":
    "0.09%",
  "ASTE1.A_65_y_ov_Indigenous_M*dr.2021-01-01.Indigenous males aged 65+ years.rate":
    "0.21%",

  "CSTM55.A_60_64_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 60 to 64 years.rate":
    "0.08%",
  "ASTE8.A_60_64_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 60 to 64 years.rate":
    "0.06%",
  "ASTE1.A_60_64_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 60 to 64 years.rate":
    "0.13%",
  "CSTM55.A_60_64_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 60 to 64 years.rate":
    "0.00%",
  "ASTE8.A_60_64_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 60 to 64 years.rate":
    "0.05%",
  "ASTE1.A_60_64_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 60 to 64 years.rate":
    "0.12%",

  "CSTM55.A_55_59_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 55 to 59 years.rate":
    "0.00%",
  "ASTE8.A_55_59_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 55 to 59 years.rate":
    "0.07%",
  "ASTE1.A_55_59_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 55 to 59 years.rate":
    "0.15%",
  "CSTM55.A_55_59_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 55 to 59 years.rate":
    "0.15%",
  "ASTE8.A_55_59_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 55 to 59 years.rate":
    "0.08%",
  "ASTE1.A_55_59_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 55 to 59 years.rate":
    "0.14%",

  "CSTM55.A_50_54_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 50 to 54 years.rate":
    "0.17%",
  "ASTE8.A_50_54_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 50 to 54 years.rate":
    "0.09%",
  "ASTE1.A_50_54_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 50 to 54 years.rate":
    "0.18%",
  "CSTM55.A_50_54_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 50 to 54 years.rate":
    "0.00%",
  "ASTE8.A_50_54_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 50 to 54 years.rate":
    "0.09%",
  "ASTE1.A_50_54_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 50 to 54 years.rate":
    "0.16%",

  "CSTM55.A_45_49_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 45 to 49 years.rate":
    "0.10%",
  "ASTE8.A_45_49_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 45 to 49 years.rate":
    "0.09%",
  "ASTE1.A_45_49_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 45 to 49 years.rate":
    "0.18%",
  "CSTM55.A_45_49_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 45 to 49 years.rate":
    "0.11%",
  "ASTE8.A_45_49_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 45 to 49 years.rate":
    "0.10%",
  "ASTE1.A_45_49_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 45 to 49 years.rate":
    "0.16%",

  "CSTM55.A_40_44_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 40 to 44 years.rate":
    "0.00%",
  "ASTE8.A_40_44_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 40 to 44 years.rate":
    "0.12%",
  "ASTE1.A_40_44_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 40 to 44 years.rate":
    "0.17%",
  "CSTM55.A_40_44_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 40 to 44 years.rate":
    "0.00%",
  "ASTE8.A_40_44_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 40 to 44 years.rate":
    "0.10%",
  "ASTE1.A_40_44_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 40 to 44 years.rate":
    "0.16%",

  "CSTM55.A_35_39_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 35 to 39 years.rate":
    "0.00%",
  "ASTE8.A_35_39_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 35 to 39 years.rate":
    "0.12%",
  "ASTE1.A_35_39_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 35 to 39 years.rate":
    "0.19%",
  "CSTM55.A_35_39_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 35 to 39 years.rate":
    "0.00%",
  "ASTE8.A_35_39_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 35 to 39 years.rate":
    "0.13%",
  "ASTE1.A_35_39_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 35 to 39 years.rate":
    "0.18%",

  "CSTM55.A_30_34_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 30 to 34 years.rate":
    "0.00%",
  "ASTE8.A_30_34_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 30 to 34 years.rate":
    "0.16%",
  "ASTE1.A_30_34_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 30 to 34 years.rate":
    "0.22%",
  "CSTM55.A_30_34_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 30 to 34 years.rate":
    "0.11%",
  "ASTE8.A_30_34_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 30 to 34 years.rate":
    "0.15%",
  "ASTE1.A_30_34_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 30 to 34 years.rate":
    "0.22%",

  "CSTM55.A_25_29_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 25 to 29 years.rate":
    "0.18%",
  "ASTE8.A_25_29_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 25 to 29 years.rate":
    "0.17%",
  "ASTE1.A_25_29_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 25 to 29 years.rate":
    "0.16%",
  "CSTM55.A_25_29_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 25 to 29 years.rate":
    "0.15%",
  "ASTE8.A_25_29_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 25 to 29 years.rate":
    "0.20%",
  "ASTE1.A_25_29_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 25 to 29 years.rate":
    "0.26%",

  "CSTM55.A_20_24_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 20 to 24 years.rate":
    "0.16%",
  "ASTE8.A_20_24_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 20 to 24 years.rate":
    "0.20%",
  "ASTE1.A_20_24_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 20 to 24 years.rate":
    "0.19%",
  "CSTM55.A_20_24_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 20 to 24 years.rate":
    "0.00%",
  "ASTE8.A_20_24_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 20 to 24 years.rate":
    "0.21%",
  "ASTE1.A_20_24_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 20 to 24 years.rate":
    "0.10%",

  "CSTM55.A_15_19_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 15 to 19 years.rate":
    "0.00%",
  "ASTE8.A_15_19_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 15 to 19 years.rate":
    "0.20%",
  "ASTE1.A_15_19_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 15 to 19 years.rate":
    "0.13%",
  "CSTM55.A_15_19_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 15 to 19 years.rate":
    "0.00%",
  "ASTE8.A_15_19_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 15 to 19 years.rate":
    "0.20%",
  "ASTE1.A_15_19_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 15 to 19 years.rate":
    "0.15%",

  "CSTM55.A_10_14_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 10 to 14 years.rate":
    "0.00%",
  "ASTE8.A_10_14_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 10 to 14 years.rate":
    "0.16%",
  "ASTE1.A_10_14_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 10 to 14 years.rate":
    "0.11%",
  "CSTM55.A_10_14_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 10 to 14 years.rate":
    "0.00%",
  "ASTE8.A_10_14_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 10 to 14 years.rate":
    "0.21%",
  "ASTE1.A_10_14_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 10 to 14 years.rate":
    "0.40%",

  "CSTM55.A_5_9_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 5 to 9 years.rate":
    "0.00%",
  "ASTE8.A_5_9_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 5 to 9 years.rate":
    "0.20%",
  "ASTE1.A_5_9_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 5 to 9 years.rate":
    "0.36%",
  "CSTM55.A_5_9_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 5 to 9 years.rate":
    "0.15%",
  "ASTE8.A_5_9_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 5 to 9 years.rate":
    "0.22%",
  "ASTE1.A_5_9_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 5 to 9 years.rate":
    "0.12%",

  "CSTM55.A_0_4_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 0 to 4 years.rate":
    "0.17%",
  "ASTE8.A_0_4_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 0 to 4 years.rate":
    "0.19%",
  "ASTE1.A_0_4_y_Indigenous_F*dr.2021-01-01.Indigenous females aged 0 to 4 years.rate":
    "0.16%",
  "CSTM55.A_0_4_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 0 to 4 years.rate":
    "0.00%",
  "ASTE8.A_0_4_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 0 to 4 years.rate":
    "0.21%",
  "ASTE1.A_0_4_y_Indigenous_M*dr.2021-01-01.Indigenous males aged 0 to 4 years.rate":
    "0.29%",
};

export default {
  reportTheme,
  items,
  indicatorValues,
  comparatorsList,
  comparatorAreaCodes,
};
